var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1751_387",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1751_387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.25 13.5C5.0375 13.5 4.85938 13.4281 4.71562 13.2844C4.57187 13.1406 4.5 12.9625 4.5 12.75V11.25H14.25V4.5H15.75C15.9625 4.5 16.1406 4.57187 16.2844 4.71562C16.4281 4.85938 16.5 5.0375 16.5 5.25V14.6813C16.5 15.0188 16.3469 15.2531 16.0406 15.3844C15.7344 15.5156 15.4625 15.4625 15.225 15.225L13.5 13.5H5.25ZM4.5 9.75L2.775 11.475C2.5375 11.7125 2.26562 11.7656 1.95938 11.6344C1.65312 11.5031 1.5 11.2688 1.5 10.9312V2.25C1.5 2.0375 1.57187 1.85938 1.71562 1.71562C1.85938 1.57187 2.0375 1.5 2.25 1.5H12C12.2125 1.5 12.3906 1.57187 12.5344 1.71562C12.6781 1.85938 12.75 2.0375 12.75 2.25V9C12.75 9.2125 12.6781 9.39063 12.5344 9.53438C12.3906 9.67813 12.2125 9.75 12 9.75H4.5ZM11.25 8.25V3H3V8.25H11.25Z",
    fill: "#4B628A"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chatIcon.3ec4b39423293a0dfcfa98d2f8a2f702.svg";
export { ForwardRef as ReactComponent };